import { call, put } from 'redux-saga/effects'

import { BLOG_STATUS_TRANSITION_TYPE } from '../../../constants/enums/blog.enum.constant'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { requestFailure, updateBlogStatusSucceed } from '../actions'

export function* updateBlogStatusSaga(
  blogApi: {
    updateBlogStatus: (...args: any[]) => any
  },
  {
    payload: { blogId, action }
  }: {
    payload: {
      blogId: string
      action: keyof typeof BLOG_STATUS_TRANSITION_TYPE
    }
  }
) {
  try {
    const { data } = yield call(blogApi.updateBlogStatus, blogId, action)
    yield put(updateBlogStatusSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
